(function () {
    'use strict';

    angular.module('swif.openbase')
    .directive('swifWizardJsonForm', swifWizardJsonForm);

    function swifWizardJsonForm() {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                fields: '=',
            }
        };
        d.templateUrl = 'partials/openbase/wizard_json_form.html';
        d.link = function (scope, element, attr, ngModel) {
            ngModel.$render = function () {
                scope.model = ngModel.$viewValue;
                scope.model.selected_tags = {};
                scope.model.all = false;
            };
            var updateSelectedTags = function () {
                scope.model.selected = [];
                if (!scope.model._vocab) {
                    return;
                }
                _.forEach(scope.model._vocab, function (categ) {
                    if (scope.model.selected_tags[categ._tag] || scope.model.all) {
                        scope.model.selected.push(categ);
                    }
                });
            };
            scope.$watch('model.selected_tags', function () {
                updateSelectedTags();
            }, true);
            scope.$watch('model.all', function (newV) {
                if (newV) {
                    updateSelectedTags();
                }
            });
        };
        return d;
    }
})();